import { useState, useEffect, useRef } from 'react';

/**
 * CountUp - anime un nombre de 0 à `end` quand il entre dans le viewport.
 * Props:
 *   end      - valeur cible (number)
 *   suffix   - ex: '+', '%', 'k+' (string)
 *   prefix   - ex: '~' (string)
 *   duration - durée en ms (default: 1800)
 */
const CountUp = ({ end, suffix = '', prefix = '', duration = 1800 }) => {
    const [count, setCount] = useState(0);
    const [started, setStarted] = useState(false);
    const ref = useRef();

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !started) {
                    setStarted(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.3 }
        );
        if (ref.current) observer.observe(ref.current);
        return () => observer.disconnect();
    }, [started]);

    useEffect(() => {
        if (!started) return;
        let startTime = null;
        const step = (timestamp) => {
            if (!startTime) startTime = timestamp;
            const progress = Math.min((timestamp - startTime) / duration, 1);
            // Easing out cubic
            const eased = 1 - Math.pow(1 - progress, 3);
            setCount(Math.floor(eased * end));
            if (progress < 1) requestAnimationFrame(step);
            else setCount(end);
        };
        requestAnimationFrame(step);
    }, [started, end, duration]);

    return (
        <span ref={ref}>
            {prefix}{count}{suffix}
        </span>
    );
};

export default CountUp;
